import * as Scrivito from "scrivito";
import defaultSocialHeaderButtonAttributes from "../_defaultSocialHeaderButtonAttributes";

const YoutubeSocialHeaderButton = Scrivito.provideObjClass(
  "YoutubeSocialHeaderButton",
  defaultSocialHeaderButtonAttributes,
);

export default YoutubeSocialHeaderButton;
